import React, { useContext, useState, useEffect } from "react";
import Flex from '@react-css/flex';
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import { StyledPartialTsDetalhado } from '../../styled-components/StyledPartialTsDetalhado.style';
import { useHistory } from 'react-router-dom';
import { ModalTimeline } from "../../components/ModalTimeline";
import { ModalTimelinePI } from "../../components/ModalTimelinePI";

export const PartialTsDetalhado = () => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);
    const [modalTimelineIsOpen, setmodalTimelineIsOpen] = useState(false);
    const [isFromProjetoInterno, setIsFromProjetoInterno] = useState(null);
    const history = useHistory();
    const goBack = () => {
        history.goBack();
    }
    
    useEffect(() => {
        if (timesheet.projetoInterno?.sigla) { 
            setIsFromProjetoInterno(true);
        }
        else {
            setIsFromProjetoInterno(false);
        }

        //console.log("PartialTsDetalhado", timesheet);
    });
    return (    
    <StyledPartialTsDetalhado>
        <div>
            <Flex className="timesheet-infs">
                <Flex.Item className="flex-column-7" xs="8" sm="8" md="8">
                <h5 className="title-row-info">
                    Informações do TimeSheet - {timesheet.timesheet.numeroTimesheet}&nbsp;
                    <span className="title-row-sub">{timesheet.timesheet.statusTimesheet}</span>
                    <a className="menu-link hover" onClick={() => setmodalTimelineIsOpen(true)}>
                    <i className="fa fa-calendar"></i>
                    </a>
                </h5>
                </Flex.Item>

                <Flex.Item className="flex-column-2 kpi" xs="1" sm="1" md="1">
                {timesheet?.timesheet?.vidaUtil && (
                    <h5 className="title-row-info text-center">
                    Vida Útil: <span className="badge bg-lightblue ml-2">{timesheet.timesheet.vidaUtil}</span>
                    </h5>
                )}
                </Flex.Item>

                <Flex.Item className="flex-column-2 kpi" xs="1" sm="1" md="1">
                {timesheet?.timesheet?.statusTimesheet === 'Em Andamento' && (
                    <h5 className="title-row-info text-center">
                    Qtd. Dias S/M: <span className="badge bg-lightblue ml-2">{timesheet.timesheet.diasSemMovimentacao}</span>
                    </h5>
                )}
                </Flex.Item>

                <Flex.Item className="flex-column-2 text-right kpi" xs="1" sm="1" md="1">
                <span className="menu-link hover btn-voltar" onClick={goBack}>
                    <i className="fa fa-arrow-circle-o-left mr-2"></i>Voltar
                </span>
                </Flex.Item>
            </Flex>
            <br />
        </div>

        {isFromProjetoInterno ? (
            <ModalTimelinePI
                isOpen={modalTimelineIsOpen}
                setIsOpen={setmodalTimelineIsOpen}
                onRequestClose={() => setmodalTimelineIsOpen(false)}
                idTimesheet={timesheet?.timesheet?.idTimesheet}
                timelineInfs={[
                    {
                        label: "Data do Sinistro",
                        value: timesheet?.sinistro.dataSinistro || "Não informado"
                    },
                    {
                        label: "Data de abertura do Sinistro",
                        value: timesheet?.sinistro.dataAbertura || "Não informado"
                    },
                    {
                        label: "Data de abertura do TS",
                        value: timesheet?.timesheet?.dataTimesheetF
                    }  
                ]}
                porEtapaAprovacao={timesheet?.timesheet?.slaPorEtapa}
                finalizacaoTS={timesheet?.sinistro.dataFinalizacaoTS}                
            >
            </ModalTimelinePI>
            ) :
            <ModalTimeline
                isOpen={modalTimelineIsOpen}
                setIsOpen={setmodalTimelineIsOpen}
                onRequestClose={() => setmodalTimelineIsOpen(false)}
                idTimesheet={timesheet?.timesheet?.idTimesheet}
                timelineInfs={[
                    {
                        label: "Data do Sinistro",
                        value: timesheet?.sinistro.dataSinistro || "Não informado"
                    },
                    {
                        label: "Data de abertura do Sinistro",
                        value: timesheet?.sinistro.dataAbertura
                    },
                    {
                        label: "Data de abertura do TS",
                        value: timesheet?.timesheet?.dataTimesheetF
                    }
                ]}
                porEtapaAprovacao={timesheet?.timesheet?.slaPorEtapa}
                finalizacaoTS={timesheet?.sinistro.dataFinalizacaoTS}
                nfDataFaturamento={timesheet?.timesheet?.dataFaturamento}
                nfDataRecebimento={timesheet?.timesheet?.dataRecebimento}
            >
            </ModalTimeline>
        }
    </StyledPartialTsDetalhado>
    );
};
